/*
 * @Author: liyxt
 * @Date: 2020-05-28 14:28:27
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-29 09:48:01
 * @Description: file content
 */ 
import React, { Component } from 'react';
//import { Col as OriginCol } from 'bee-layout';
import { Col as OriginCol } from '@tinper/next-ui';
import { getSysFieldid } from '@platform/api';

// require('bee-layout/build/Layout.css');

export default class Col extends Component {
    render() {
        let {
            fieldid,
            xsPull,
            smPull,
            mdPull,
            lgPull,
            xsPush,
            smPush,
            mdPush,
            lgPush,
            xsOffset,
            smOffset,
            mdOffset,
            lgOffset,
            pageClassType,
            className,
            ...others
        } = this.props;
        fieldid = getSysFieldid(fieldid);
        let pull = others.pull||xsPull||smPull||mdPull||lgPull;
        let push = others.push||xsPush||smPush||mdPush||lgPush;
        let offset = others.offset||xsOffset||smOffset||mdOffset||lgOffset;
        return <OriginCol {...others} className={className} pull={pull} push={push} offset={offset} fieldid={fieldid} />;
    }
}
